import config from '../config'
import query from '../api/BaseApi'

export default class movie_results {
  constructor() {
    this.host = config.movie_host;
    this.model = 'movie_result';
  }
  async query({ host = this.host, method, urlParams, bodyPayload, pathPrefix = '/api/v1/', model = this.model, path = '', headers = null }) {
    return await query({
      host: host,
      method: method,
      urlParams: urlParams,
      bodyPayload: bodyPayload,
      pathPrefix: pathPrefix,
      model: model,
      path: path,
      headers: headers,
    })
  }
  async searchMovieResult(bodyPayload = { title: "", sort: "", offset: "", tag_ids: [], year: "", page: 1, per_page: 10 }) {
    return await this.query({
      method: 'POST',
      bodyPayload: bodyPayload,
    })
  }

}